import React, { useEffect, useState } from "react";
import { Formik, Field } from "formik";
import {
  Button,
  Form,
  FormGroup,
  Container,
  Col,
  Label,
  Input,
} from "reactstrap";
import * as Yup from "yup";
import MultiSelect from "@kenshooui/react-multi-select";
import ErrorMessage from "../../Utils/ErrorMessage";
import { connect, useDispatch } from "react-redux";
import Mapping from "../../Utils/Mapping";
import { Link, useParams } from "react-router-dom";
import {
  getRoles,
  createUser,
  getUserDetails,
  modifyUser,
} from "../../../actions/users";
import { Loading } from "../../../loader/Loading";
import SubmissionPopup from "./submissionModal";
import errors from "../../Constants/errors.json";
import DocumentTitle from "react-document-title";
import { isEmpty } from "lodash";
import ErrorFocus from "../../Error/ErrorFocus";
const InternalUserForm = (props) => {
  const [state, setState] = useState({
    modal: false,
    message: "",
    color: "",
    user: {},
    accessroles: [],
    initialAccessroles: [],
    existingStatus: false,
    aTouch: false,
  });

  const dispatch = useDispatch();
  const clearError = () => {
    dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
  };
  // const clearRoles = () => {
  //   dispatch({ type: "SET_ROLES_LIST", data: { roles: undefined } });
  // };
  const clearUserCreated = () => {
    dispatch({ type: "SET_CREATE_USER", data: { usercreated: undefined } });
  };
  // const clearUserDetails = () => {
  //   dispatch({ type: "SET_USER_DETAILS", data: { userDetails: undefined } });
  // };
  const getUserDetailsMethod = (username) => dispatch(getUserDetails(username));
  // const getRolesMethod = () => dispatch(getRoles());
  const createUserMethod = (createUserObject) =>
    dispatch(createUser(createUserObject));
  const modifyUserMethod = (updateUserObject) =>
    dispatch(modifyUser(updateUserObject));
  const clearModifyUser = () => {
    dispatch({ type: "SET_MODIFY_USER", data: { userModified: undefined } });
  };

  const { userDetails, userCreated, userModified, roles, error, isLoading } =
    props;

  const toggle = () => {
    let newState = {
      modal: !state.modal,
      message: "",
      color: "",
    };
    setState((prevState) => ({
      ...prevState,
      ...newState,
    }));
    state.userID && !error && getUserDetailsMethod(state.userID);
  };

  useEffect(() => {
    let newState = {};
    if (userCreated) {
      newState = {
        modal: true,
        message: userCreated,
        color: "success",
      };
    } else if (error) {
      let errorMessage = (error.code &&
        error.code.message &&
        error.code.message.message) ||
        error.message || <Mapping dictionary={errors} word={error.errorPath} />;
      newState = { modal: true, message: errorMessage, color: "danger" };
    } else if ((userDetails && roles && roles.length > 0) || userModified) {
      let userRoles = userDetails["custom:Groups"];
      let userRolesArray = (userRoles && userRoles.split(",")) || [];
      let finalRolesObjectArray = userRolesArray
        .map((userrole) => {
          return roles.find((role) => role.id === userrole);
        })
        .filter((r) => r);
      let nAccessRoles = state.aTouch
        ? state.accessroles
        : finalRolesObjectArray;
      newState = {
        accessroles: nAccessRoles,
        modal: userModified ? true : false,
        message: userModified ? "User Modified Successfully" : "",
        color: userModified ? "success" : "",
      };
    }
    if (Object.keys(newState).length > 0) {
      setState((prevState) => ({
        ...prevState,
        ...newState,
      }));
    }
  }, [
    userCreated,
    userDetails,
    userModified,
    roles,
    error,
    state.aTouch,
    state.accessroles,
  ]);

  const temp = useParams()["*"];
  const userId = temp !== "create" ? temp : undefined;

  useEffect(() => {
    dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
    dispatch(getRoles());
    dispatch({ type: "SET_CREATE_USER", data: { usercreated: undefined } });
    if (userId) {
      let newState = {
        userID: userId,
        disabled: true,
      };
      setState((prevState) => ({
        ...prevState,
        ...newState,
      }));
      dispatch(getUserDetails(userId));
    }
  }, [dispatch, userId]);

  useEffect(() => {
    return () => {
      let newState = {
        modal: false,
        message: "",
        color: "",
      };
      setState((prevState) => ({
        ...prevState,
        ...newState,
      }));
      dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
      dispatch(getRoles());
      dispatch({ type: "SET_CREATE_USER", data: { usercreated: undefined } });
      dispatch({ type: "SET_USER_DETAILS", data: { userDetails: undefined } });
    };
  }, [dispatch]);

  const createUserObject = (formvalues) => {
    const { firstName, lastName, userid, email } = formvalues;
    let accessRoleFormat =
      state.accessroles && state.accessroles.length > 0
        ? state.accessroles.map((role) => role.id)
        : [];
    let finalArray = [];
    let object = {
      email: email,
      preferred_username: userid || " ",
      // 'custom:uid': userid || ' ',
      given_name: firstName || " ",
      family_name: lastName || " ",
      "custom:displayname": `${lastName},${firstName}` || " ",
      "custom:Groups":
        accessRoleFormat.length > 0 ? accessRoleFormat.join(",") : " ",
    };
    Object.keys(object).forEach((key) => {
      finalArray.push({
        Name: key,
        Value: object[key],
      });
    });
    return { Attributes: finalArray, internalUseronly: true, email: email };
  };

  const updateUserObject = (formvalues) => {
    // const { email } = formvalues;
    let accessRoleFormat =
      state.accessroles && state.accessroles.length > 0
        ? state.accessroles.map((role) => role.id)
        : [];
    let finalArray = [];
    let appSpecificRoles = roles.map((role) => role.id);
    let userAccessRole = userDetails["custom:Groups"];
    let originalAccessroles =
      (userAccessRole && userAccessRole !== " " && userAccessRole.split(",")) ||
      [];
    let filteredOriginalAccessRoles =
      originalAccessroles.length > 0
        ? originalAccessroles.filter(
            (role) => !appSpecificRoles.includes(role) && role !== " "
          )
        : [];

    let finalRoles = filteredOriginalAccessRoles.concat(accessRoleFormat);
    let object = {
      "custom:Groups": finalRoles.length > 0 ? finalRoles.join(",") : " ",
    };
    Object.keys(object).forEach((key) => {
      finalArray.push({
        Name: key,
        Value: object[key],
      });
    });
    return {
      Attributes: finalArray,
      internalUseronly: true,
      email: state.userID,
    };
  };

  return (
    <DocumentTitle
      title={`Doorkeeper | ${!state.userID ? "Create User" : "Modify User"}`}
    >
      <React.Fragment>
        <h5>{!state.userID ? "Create User" : "Modify User"}</h5>
        <Formik
          enableReinitialize={true}
          initialValues={{
            firstName: (userDetails && userDetails.given_name) || "",
            lastName: (userDetails && userDetails.family_name) || "",
            email: (userDetails && userDetails["email"]) || "",
            accessroles: (userDetails && state.accessroles) || [],
            userid: (userDetails && userDetails["preferred_username"]) || "",
          }}
          validationSchema={Yup.object().shape({
            email: Yup.string()
              .required("Email is required")
              .email("Invalid email"),
            userid: Yup.string().required("GID is required"),
            firstName: Yup.string()
              .required("First Name is required")
              .test("validateFirstName", "Invalid First Name", (firstName) => {
                return isEmpty(String(firstName).trim()) ? false : true;
              }),
            lastName: Yup.string()
              .required("Last Name is required")
              .test("validateLastName", "Invalid Last Name", (lastName) => {
                return isEmpty(String(lastName).trim()) ? false : true;
              }),
          })}
          onSubmit={(values) => {
            if (state.userID) {
              let formattedValues = updateUserObject(values);
              modifyUserMethod(formattedValues);
            } else {
              let formattedValues = createUserObject(values);
              createUserMethod(formattedValues);
            }
          }}
          onReset={() => {
            clearError();
            setState({
              modal: false,
              message: "",
              color: "",
            });
            if (state.userID) {
              clearModifyUser();
            } else {
              setState({ accessroles: [] });
              clearUserCreated();
            }
          }}
        >
          {({
            handleSubmit,
            values,
            handleBlur,
            touched,
            errors,
            setFieldValue,
            handleReset,
            isSubmitting,
            isValidating,
          }) => (
            <Container
              style={{
                border: "1.5px solid #ddd",
                padding: "1% 5%",
                overflowY: "auto",
                height: "70vh",
              }}
            >
              {isLoading && !error && <Loading />}
              {state.modal && (
                <SubmissionPopup
                  modal={state.modal}
                  toggle={() => {
                    toggle();
                    handleReset();
                  }}
                  message={state.message}
                  color={state.color}
                />
              )}
              <Form onSubmit={handleSubmit}>
                <ErrorFocus
                  errors={errors}
                  isSubmitting={isSubmitting}
                  isValidating={isValidating}
                />
                <FormGroup row>
                  <Col>
                    <Label>
                      GID:<span className="required">*</span>
                      {"  "}
                    </Label>
                    <Input
                      type="userid"
                      name="userid"
                      tag={Field}
                      onBlur={handleBlur}
                      disabled={state.disabled}
                      onChange={(event) => {
                        setFieldValue("userid", event.target.value);
                      }}
                    />
                    <ErrorMessage
                      errors={errors.userid}
                      touched={touched.userid}
                    />{" "}
                  </Col>

                  <Col>
                    <Label>
                      Email ID:<span className="required">*</span>
                      {"  "}
                    </Label>
                    <Input
                      type="email"
                      name="email"
                      tag={Field}
                      onBlur={handleBlur}
                      disabled={state.disabled}
                      onChange={(event) => {
                        setFieldValue("email", event.target.value);
                      }}
                    />
                    <ErrorMessage
                      errors={errors.email}
                      touched={touched.email}
                    />{" "}
                  </Col>
                </FormGroup>

                <FormGroup row>
                  <Col>
                    <Label>
                      First Name:<span className="required">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="firstName"
                      tag={Field}
                      maxLength={30}
                      onBlur={handleBlur}
                      disabled={state.disabled}
                      onChange={(event) => {
                        setFieldValue("firstName", event.target.value);
                      }}
                    />
                    <ErrorMessage
                      errors={errors.firstName}
                      touched={touched.firstName}
                    />{" "}
                  </Col>
                  <Col>
                    <Label>
                      Last Name:<span className="required">*</span>
                      {"  "}
                    </Label>
                    <Input
                      type="text"
                      name="lastName"
                      tag={Field}
                      maxLength={30}
                      onBlur={handleBlur}
                      disabled={state.disabled}
                      onChange={(event) => {
                        setFieldValue("lastName", event.target.value);
                      }}
                    />
                    <ErrorMessage
                      errors={errors.lastName}
                      touched={touched.lastName}
                    />{" "}
                  </Col>
                </FormGroup>
                {roles && roles.length > 0 && (
                  <FormGroup row>
                    <Col md={4}>
                      <Label className="floatLeft">Access Role(s):</Label>
                    </Col>
                    <Col md={12}>
                      <MultiSelect
                        responsiveHeight={"100%"}
                        name={"accessroles"}
                        items={roles}
                        selectedItems={state.accessroles}
                        onChange={(accessroles) => {
                          setState({
                            accessroles: accessroles,
                            aTouch: true,
                          });
                          setFieldValue("accessroles", accessroles);
                        }}
                      />
                      <ErrorMessage
                        errors={errors.accessroles}
                        touched={touched.accessroles}
                      />{" "}
                    </Col>
                  </FormGroup>
                )}
                <FormGroup row>
                  <Col className="text-center text-md-right">
                    <Button
                      type="reset"
                      tag={Link}
                      to={state.userID ? "/modify" : "/"}
                    >
                      Cancel
                    </Button>
                    &nbsp;
                    <Button type="submit">Submit</Button>
                  </Col>
                </FormGroup>
              </Form>
            </Container>
          )}
        </Formik>
      </React.Fragment>
    </DocumentTitle>
  );
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.fetch.isLoading,
    error: state.error.error_obj,
    userDetails: state.users.userDetails,
    roles: state.users.roles,
    // companies: state.users.companies,
    pool: state.pool.userPool,
    userCreated: state.users.usercreated,
    userModified: state.users.userModified,
  };
};

export default connect(mapStateToProps)(InternalUserForm);
